const usernameAbbrLength = 3;

export default class User {
  public static abbrUserName(username: string) {
    if (!username) {
      return username;
    }
    const match = username.match(/\b[A-Z]/g);
    if (!match) {
      return username.substring(0, usernameAbbrLength);
    }
    return match.slice(0, usernameAbbrLength).join('');
  }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/auth/user.tsx